import React, { useEffect, useState } from "react";
import { Col, Container } from "react-bootstrap";
import Card from "../../../components/Card";
import { Link } from "react-router-dom";
import ProfileHeader from "../../../components/profile-header";
import img7 from "../../../assets/images/page-img/profile-bg6.jpg";
import axios from "axios";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import { Oval } from "react-loader-spinner";
import Error500 from "../errors/error500";
import Skeleton from "react-loading-skeleton";
import Loading from "../../../components/common/Loading";

const Groups = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const users = JSON.parse(localStorage.getItem("users"));

  const getGroups = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(webServiceUrl.groupsEnrolled, { users });
      setData(response.data?.enrolledCourses || []);
    } catch (error) {
      console.error("Groups fetch error:", error);
      setApiError(true);
    } finally {
      // simulate loading delay
      setTimeout(() => setIsLoading(false), 2000);
    }
  };

  useEffect(() => {
    getGroups();
  }, []);

  useEffect(() => {
    setTimeout(() => setPageLoading(false), 1500)
  }, [])

  if (pageLoading) {
    return (
      <>
        {/* <div className="d-flex py-6 d-flex justify-content-center" style={{ minHeight: "90vh", padding: "4rem" }}>
        <Loading />
      </div> */}
        <div
          className="d-flex justify-content-center "
          style={{ height: "85vh", paddingTop: "15vh" }}
        >
          <Oval
            height="50"
            width="50"
            color="#4fa94d"
            secondaryColor="#4fa94d"
          />
        </div>
      </>
    );
  }

  return (
    <>
      <ProfileHeader img={img7} title="Groups" />
      <div id="content-page" className="content-inner">
        <Container>
          {apiError ? (
            <Col>
              <Error500 />
            </Col>
          ) : data.length === 0 ? (
            <p className="text-center mt-4 fs-4">No groups found.</p>
          ) : (
            <div className="row ">
              {data.map((item, index) => (
                <div className=" col-12 col-md-6 col-lg-4 mb-4" key={index}>
                  <Card className="group-box shadow-sm w-100 h-100">
                    <Card.Body className="text-center px-2 pb-2">

                <div
  className="image-block position-relative productCardImg"
  style={{ height: "200px", width: "100%" }}
>
  {isLoading && <Skeleton height={200} className="rounded-3" />}

  <div
    className="d-flex align-items-center justify-content-center"
    style={{
      height: "100%",
      width: "100%",
      overflow: "hidden",
    }}
  >
    <img
      src={item?.logo_image}
      alt="product-img"
      style={{
        display: isLoading ? "none" : "block",
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain", // ⭐ no crop
      }}
      onLoad={() => setIsLoading(false)}
    />
  </div>
</div>
                      {/* <div className="image-block position-relative productCardImg overflow-hidden">
                        {isLoading && <Skeleton height={200} className="rounded-3" />}
                        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
                          <img
                            src={item?.logo_image}
                            className="img-fluid group-detail-post-image object-fit-cover rounded"
                            alt="product-img"
                            style={{ display: isLoading ? "none" : "block" }}
                          // onLoad={() => setLoading(false)}
                          />
                         
                        </div>
                      </div> */}
                        {/* <h6 className="price cursor-pointer secondaryBG ">Enroll Now</h6> */}

                      {/* <div className="image-block position-relative productCardImg overflow-hidden p-3 d-flex align-items-center justify-content-center rounded-3 border">
                        {isLoading && <Skeleton height={200} className="rounded-3" />}
                        <img
                          src={item?.logo_image}
                          className="img-fluid group-detail-post-image object-fit-cover rounded "
                          alt="product-img"
                          style={{ display: isLoading ? "none" : "block" }}
                        // onLoad={() => setLoading(false)}
                        />
                      </div> */}

                      <div className="group-info mt-3 mb-2">
                        <Link
                          to={`/dashboards/app/group-detail/${item.school_code}`}
                          state={{ item }}
                          className="h4"
                        >
                          {item.school_name}
                        </Link>
                      </div>

                      <div className="group-details pb-4 mb-4 border-bottom">
                        <ul className="d-flex align-items-center justify-content-center list-inline m-0 p-0 gap-3">
                          <li>
                            <div className="d-flex align-items-center gap-1">
                              <span className="material-symbols-outlined font-size-18">
                                description
                              </span>
                              <span>{item?.student?.posts} posts</span>
                            </div>
                          </li>
                          <li>
                            <div className="d-flex align-items-center gap-1">
                              <span className="material-symbols-outlined font-size-18">
                                group
                              </span>
                              <span>{item?.student?.members} Members</span>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <Link
                        to={`/dashboards/app/group-detail/${item.school_code}`}
                        state={{ item }}
                        className="btn btn-primary-subtle mb-0 fw-semibold px-3"
                      >
                        View Group
                      </Link>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </div>
          )}
        </Container>
      </div>
    </>
  );
};

export default Groups;
